import React from 'react'
// import {Button} from "@mui/material"; // No longer directly used
import { StyledButton } from '../Buttons/DefaultButton/DefaultButton.styles';

import {JobTitle} from "components/JobTitle";
import {HygienistBackendJob} from "components/EditJob";
import {Location} from "components/BillingLocationSelector";
import {JobInfo} from "./JobInfo";

import {ContentContainer, ButtonContainer} from "./HygienistJobDetails.styles";

interface HygienistJobDetailsProps {
  job: HygienistBackendJob
  onApply: () => void
  onWithdraw: () => void
}

const HygienistJobDetails = ({job, onApply, onWithdraw}: HygienistJobDetailsProps) => {
  return (
    <>
      <ContentContainer>
        <JobTitle
          title={job.title || ''}
          {...(job.location
            ? {
              practiceName: job.location.practiceName,
              location: {
                address: job.location.address,
                city: job.location.city,
                province: job.location.province
              } as Location
            }
            : {})}
        />
        <JobInfo job={job}/>
      </ContentContainer>
      <ButtonContainer>
        <StyledButton
          variant={job.isApplied ? "outlined" : "contained"}
          onClick={job.isApplied ? onWithdraw : onApply}
          color="primary"
          size="large" // StyledButton might override this or use it, check DefaultButton.styles.ts if needed
          id="apply-button" // Keep id if used for testing or other logic
          // className="bigButtonInNewStyle" // Remove as StyledButton handles its own styling
        >
          {job.isApplied ? 'Withdraw my application' : 'Apply'}
        </StyledButton>
      </ButtonContainer>
    </>
  )
}

export default HygienistJobDetails;
